export const InfinifiFees = {
    Lock: 0.3 / 100.0, // 0.3%
} as const;

export type Fee = keyof typeof InfinifiFees; /**
 * Applies a fee to a given amount.
 * @param amount The amount to which the fee will be applied.
 * @param fee The fee type to apply.
 * @param dp The number of decimal places to consider (optional).
 * @returns The amount after applying the fee.
 * @example 100.00 with 0.3 (%) fee becomes 99.70
 */
export const applyFee = (amount: number | bigint, feePct: number, dp?: number): number | bigint => {
    if (feePct === 0) return amount;
    if (typeof amount === "bigint") return applyFeeToBigInt(amount, feePct, dp);
    return applyFeeToNumber(amount, feePct);
};

const applyFeeToBigInt = (amount: bigint, fee: number, dp?: number): bigint => {
    const precision = dp ? BigInt(10 ** dp) : 1_000_000n; // Use 6 decimal places for percentage calculations

    // Convert fee to fixed-point bigint (e.g., 0.3% becomes 3000 at 6 decimal precision)
    const feeBigInt = BigInt(Math.round(fee * Number(precision)));

    // Calculate (1 - fee) with precision (e.g., 1 - 0.3% = 0.997 becomes 997000)
    const multiplier = precision - feeBigInt;

    // Apply the fee and scale back to original units
    return (amount * multiplier) / precision;
};

const applyFeeToNumber = (amount: number, fee: number): number => amount * (1 - fee);
